import { render, staticRenderFns } from "./MessagesAdmin.vue?vue&type=template&id=9b9c531e&"
import script from "./MessagesAdmin.vue?vue&type=script&lang=js&"
export * from "./MessagesAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports